import { WorkOrdersPage } from "../../pages/workOrders";

export const routeWorkOrders = "/work-orders";
export const routeWorkOrdersByAsset = "/work-orders/:assetName";

export const workOrdersRoutes = [
	{
		path: routeWorkOrders,
		element: <WorkOrdersPage />,
	},
	{
		path: routeWorkOrdersByAsset,
		element: <WorkOrdersPage />,
	},
];
